import type { Point2D } from '@aninix-inc/model/legacy'

import { BezierPoint } from './bezier-point'

type Payload = {
  position: Point2D
  size: Point2D
}

export function rectToBezier({ position, size }: Payload): BezierPoint[] {
  return [
    new BezierPoint({ point: position }),
    new BezierPoint({
      point: {
        x: position.x + size.x,
        y: position.y,
      },
    }),
    new BezierPoint({
      point: {
        x: position.x + size.x,
        y: position.y + size.y,
      },
    }),
    new BezierPoint({
      point: {
        x: position.x,
        y: position.y + size.y,
      },
    }),
    new BezierPoint({ point: position }),
  ]
}
